import script from "./CardHitosPago.vue?vue&type=script&setup=true&lang=js"
export * from "./CardHitosPago.vue?vue&type=script&setup=true&lang=js"

import "./CardHitosPago.vue?vue&type=style&index=0&id=51cd633a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51cd633a"]])

export default __exports__